import { createStore } from 'solid-js/store';
import { createMagicDoorContext } from '~/contexts/utils';
import type { LeaseMoveOutRequestDto } from '~/swagger/Api';

export const [MoveOutRequestTableProvider, useMoveOutRequestsTable] = createMagicDoorContext('MoveOutRequestTableContext', () => {
  const [store, setStore] = createStore({
    selectedRequest: null as LeaseMoveOutRequestDto | null,
    isViewModalOpen: false,
  });

  return { store, setStore };
});
